import React, { useState } from "react";
import {
  PriceHistoryWidget,
  PriceHistoryWidgetProps,
  WidgetError,
  WidgetMessage,
  ThemeType,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";
import moment from "moment";

const StockPeerComparison: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const [symbol, setSymbol] = useState(queryParams.get("symbol") || "");
  const [theme, setTheme] = useState(
    queryParams.get("theme") || ThemeType.Direct,
  );
  const [frDate, setFrDate] = useState(
    queryParams.get("frDate") ||
      moment().subtract(6, "months").format("YYYY-MM-DD"),
  );
  const [toDate, setToDate] = useState(queryParams.get("toDate") || undefined);
  const token = queryParams.get("token") || "";

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.PriceHistory,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: PriceHistoryWidgetProps = {
    symbol: symbol,
    frDate: frDate,
    toDate: toDate,
    token: token,
    theme: theme as ThemeType,
    onError: handleError,
    onNoData: handleNoData,
    onLoadingChange: handleLoadingChange,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <PriceHistoryWidget {...props} />
    </Spin>
  );
};

export default StockPeerComparison;
